<script lang="ts">
const __DsBlock = {
	type: 'input',
	icon: 'lucide:rectangle-ellipsis',
	name: '$t:blocks.input_password.name',
	description: '$t:blocks.input_password.description',
	category: 'input',
	tags: ['form-control'],
	options: [
		{
			name: 'modelValue',
			model: true,
		},
		{
			name: 'placeholder',
		},
		{
			name: 'color',
			type: 'enum',
			values: BLOCK_COLOR_OPTIONS,
		},
		{
			name: 'variant',
			type: 'enum',
			values: BLOCK_INPUT_VARIANT_OPTIONS,
		},
		{
			name: 'size',
			type: 'enum',
			values: BLOCK_CONTROL_SIZE_OPTIONS,
		},
		{
			name: 'icon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'trailing',
		},
		{
			name: 'leadingIcon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'trailingIcon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'showIcon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'hideIcon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'disabled',
		},
		{
			name: 'disabledNotice',
		},
		{
			name: 'readonly',
		},
		{
			name: 'autocomplete',
		},
		{
			name: 'modelModifiers',
			hidden: true,
		},
	],
}
</script>
<script lang="ts" setup>
import type { InputPasswordProps } from '#layers/ui';
import type { InputBlockProps } from '~/types/input-block';
import { reactivePick } from '@vueuse/core';
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';

import { defineBlock } from '#layers/block-engine';
import { BLOCK_COLOR_OPTIONS, BLOCK_CONTROL_SIZE_OPTIONS, BLOCK_INPUT_VARIANT_OPTIONS } from '#layers/blocks/constants/ui-options';
import { useDisabledNotice } from '#layers/ui';
import { usePrimitiveFormField } from '~/composables/form-block/use-primitive-form-field';

interface Props extends
	InputBlockProps,
	Omit<InputPasswordProps, 'readonly'> {
}

const props = defineProps<Props>();

const model = defineModel<string>();

const forwarded = reactivePick(props, 'placeholder', 'color', 'variant', 'size', 'icon', 'leadingIcon', 'trailing', 'trailingIcon', 'showIcon', 'hideIcon', 'autocomplete', 'readonly');

;

const { modelValue, disabled, disabledNotice } = usePrimitiveFormField(props, { model });
const { showDisabledNotice } = useDisabledNotice({ disabled, disabledNotice });
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<DInputPassword
			v-bind="forwarded"
			v-model="modelValue"
			:model-modifiers="modelModifiers ?? {}"
			:disabled
			:aria-readonly="readonly"
			class="min-w-0"
		/>
	</DTooltip>
</template>
